module.exports = __webpack_public_path__ + "static-portal/img/map-rtzf2.c557f22.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/map-rtzf2.jpg
// module id = WMyW
// module chunks = 4